import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-24 bg-warm-bg" data-id="element-13">
      <div className="max-w-5xl mx-auto px-6" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16" data-id="element-15">
          <FadeIn data-id="element-16">
            <h2 className="text-3xl font-heading text-warm-dark mb-8" data-id="element-17">
              Este ebook <span className="text-sage italic" data-id="element-18">SÍ es para ti</span>{' '}
              si...
            </h2>
            <ul className="space-y-6" data-id="element-19">
              {['Sufres de dolor de espalda, dolor lumbar, ciática o hernias discales.', 'Estás cansado/a de información confusa y contradictoria en internet.', 'Sientes miedo, frustración o soledad a raíz de tu diagnóstico.', 'Buscas una guía clara, humana y empática que te entienda.', 'Quieres entender qué cosas prácticas pueden ayudarte en tu día a día.'].map((item, i) => <li key={i} className="flex gap-4" data-id="element-20">
                  <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-sage/20 flex items-center justify-center" data-id="element-21">
                    <Check className="w-4 h-4 text-sage" data-id="element-22" />
                  </div>
                  <span className="text-warm-dark/80 leading-relaxed" data-id="element-23">
                    {item}
                  </span>
                </li>)}
            </ul>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-24">
            <h2 className="text-3xl font-heading text-warm-dark mb-8" data-id="element-25">
              Este ebook{' '}
              <span className="text-red-400/80 italic" data-id="element-26">NO es para ti</span>{' '}
              si...
            </h2>
            <ul className="space-y-6" data-id="element-27">
              {["Buscas soluciones mágicas, parches rápidos o 'curas garantizadas'.", 'Quieres reemplazar la atención médica profesional o la fisioterapia.', 'Esperas un manual médico lleno de tecnicismos y diagnósticos clínicos.', 'No estás dispuesto/a a tomar un rol activo en tu propia recuperación.'].map((item, i) => <li key={i} className="flex gap-4" data-id="element-28">
                  <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-red-100 flex items-center justify-center" data-id="element-29">
                    <X className="w-4 h-4 text-red-400" data-id="element-30" />
                  </div>
                  <span className="text-warm-dark/80 leading-relaxed" data-id="element-31">
                    {item}
                  </span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
}